import { render, staticRenderFns } from "./CampaignStatistics.vue?vue&type=template&id=1c358f8c&scoped=true&"
import script from "./CampaignStatistics.vue?vue&type=script&lang=js&"
export * from "./CampaignStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatistics.vue?vue&type=style&index=0&id=1c358f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c358f8c",
  null
  
)

export default component.exports